// src/hooks/useRateLimit.js
import { useState, useEffect, useCallback } from "react";

export function useRateLimit(key = "attempt", maxAttempts = 5, lockMs = 60000) {
  const storageKey = `rateLimit_${key}_attempts`;
  const lockKey = `rateLimit_${key}_lockUntil`;

  const [attempts, setAttempts] = useState(
    parseInt(sessionStorage.getItem(storageKey)) || 0
  );
  const [lockUntil, setLockUntil] = useState(
    parseInt(sessionStorage.getItem(lockKey)) || 0
  );
  const [isLocked, setIsLocked] = useState(false);

  useEffect(() => {
    const now = Date.now();
    if (attempts >= maxAttempts && now < lockUntil) {
      setIsLocked(true);
    } else {
      setIsLocked(false);
    }
  }, [attempts, lockUntil, maxAttempts]);

  const registerFailure = useCallback(() => {
    const newAttempts = attempts + 1;
    sessionStorage.setItem(storageKey, newAttempts);
    setAttempts(newAttempts);

    if (newAttempts >= maxAttempts) {
      const until = Date.now() + lockMs;
      sessionStorage.setItem(lockKey, until);
      setLockUntil(until);
      setIsLocked(true);
    }
  }, [attempts, maxAttempts, lockMs, storageKey, lockKey]);

  const reset = useCallback(() => {
    sessionStorage.removeItem(storageKey);
    sessionStorage.removeItem(lockKey);
    setAttempts(0);
    setLockUntil(0);
    setIsLocked(false);
  }, [storageKey, lockKey]);

  useEffect(() => {
    if (isLocked) {
      const interval = setInterval(() => {
        if (Date.now() > lockUntil) {
          reset();
        }
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [isLocked, lockUntil, reset]);

  return { attempts, isLocked, registerFailure, reset };
}
